(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-zt-metal-selector]').forEach(setup);
  }

  function setup(root) {
    if (root.dataset.ztMetalReady === 'true') return;

    var variantPicker = root.closest('variant-selects, variant-radios');
    if (!variantPicker) return;

    var dataEl = variantPicker.querySelector('[data-zt-all-variant-data]');
    if (!dataEl) return;

    var variants;

    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var purityPos = Number(root.dataset.ztPurityPos);
    var colorPos = Number(root.dataset.ztColorPos);

    var optionGroups = Array.from(
      variantPicker.querySelectorAll('.product-form__input')
    );

    var purityGroup = optionGroups[purityPos];
    var colorGroup = optionGroups[colorPos];

    if (!purityGroup || !colorGroup) return;

    var list = root.querySelector('[data-zt-metal-list]');
    var triggerText = root.querySelector('[data-zt-metal-trigger-text]');
    var triggerSwatch = root.querySelector('[data-zt-metal-trigger-swatch]');
    var details = root.querySelector('[data-zt-metal-details]');

    if (!list || !triggerText || !triggerSwatch || !details) return;

    function getGroupValue(group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;

      var select = group.querySelector('select');
      if (select) return select.value;

      return null;
    }

    function setGroupValue(group, value) {
      var radios = Array.from(
        group.querySelectorAll('input[type="radio"]')
      );

      var radio = radios.find(function (input) {
        return input.value === value;
      });

      if (radio) {
        radio.checked = true;
        return radio;
      }

      var select = group.querySelector('select');

      if (select) {
        select.value = value;
        return select;
      }

      return null;
    }

    function getCurrentSelections() {
      return optionGroups.map(function (group) {
        return getGroupValue(group);
      });
    }

    function swatchClass(color) {
      var value = String(color || '').toLowerCase();

      if (value.indexOf('rose') !== -1) {
        return 'zt-metal-swatch-rose';
      }

      if (value.indexOf('white') !== -1) {
        return 'zt-metal-swatch-white';
      }

      return 'zt-metal-swatch-yellow';
    }

    function getStatus(purity, color) {
      var selections = getCurrentSelections();

      selections[purityPos] = purity;
      selections[colorPos] = color;

      var variant = variants.find(function (variant) {
        var opts = [variant.option1, variant.option2, variant.option3];

        return opts.every(function (value, index) {
          return selections[index] == null || value === selections[index];
        });
      });

      if (variant && Number(variant.inventory_quantity) > 0) {
        return 'IN STOCK';
      }

      return 'MADE TO ORDER';
    }

    function getCombinations() {
      var seen = {};
      var combinations = [];

      variants.forEach(function (variant) {
        var opts = [variant.option1, variant.option2, variant.option3];

        var purity = opts[purityPos];
        var color = opts[colorPos];

        if (!purity || !color) return;

        var key = purity + '||' + color;

        if (!seen[key]) {
          seen[key] = true;

          combinations.push({
            purity: purity,
            color: color
          });
        }
      });

      return combinations;
    }

    function updateTrigger() {
      var purity = getGroupValue(purityGroup);
      var color = getGroupValue(colorGroup);

      if (!purity || !color) return;

      triggerText.textContent = purity + ' ' + color;

      triggerSwatch.className =
        'zt-metal-trigger-swatch ' + swatchClass(color);
    }

    function render() {
      list.innerHTML = '';

      var currentPurity = getGroupValue(purityGroup);
      var currentColor = getGroupValue(colorGroup);

      getCombinations().forEach(function (combo) {
        var li = document.createElement('li');

        li.className = 'zt-metal-option';

        if (
          combo.purity === currentPurity &&
          combo.color === currentColor
        ) {
          li.classList.add('is-selected');
        }

        li.innerHTML =
          '<span class="zt-metal-option-swatch ' +
          swatchClass(combo.color) +
          '" aria-hidden="true"></span>' +
          '<span class="zt-metal-option-name">' +
          combo.purity +
          ' ' +
          combo.color +
          '</span>' +
          '<span class="zt-metal-option-status">' +
          getStatus(combo.purity, combo.color) +
          '</span>';

        li.addEventListener('click', function () {
          var purityControl = setGroupValue(
            purityGroup,
            combo.purity
          );

          var colorControl = setGroupValue(
            colorGroup,
            combo.color
          );

          updateTrigger();
          details.removeAttribute('open');

          var control = colorControl || purityControl;

          if (control) {
            control.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          }

          window.setTimeout(function () {
            render();
            updateTrigger();
          }, 50);
        });

        list.appendChild(li);
      });

      updateTrigger();
    }

    root.dataset.ztMetalReady = 'true';

    purityGroup.classList.add('zt-metal-native-hidden');
    colorGroup.classList.add('zt-metal-native-hidden');

    variantPicker.addEventListener('change', function () {
      window.setTimeout(function () {
        render();
        updateTrigger();
      }, 25);
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();